export const getUserDataFromSession = () => {
  try {
    const userData = sessionStorage.getItem('userData');
    if (userData) {
      return JSON.parse(userData);
    }
    return null; // or you can return {} if you prefer an empty object
  } catch (error) {
    console.error('Error retrieving user data from sessionStorage:', error);
    return null;
  }
};